export enum ActiveSupervisorQueueType {
  SET_QUEUE = "SET_QUEUE",
  SET_CURRENTTAB = "SET_CURRENTTAB",
  SET_AUDIOLIB = "SET_AUDIOLIB",
  SET_PAYLOAD = "SET_PAYLOAD",
  SET_CLEARFLAG = "SET_CLEARFLAG",
}
